import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';
import { useBrands } from '@/models/brand';
import { useCurrentOrganization } from '@/services/auth';

import { CreateAgreementButton } from '../../CreateAgreementButton';
import { useFilters } from '../FiltersState';

import { FiltersAgreementType } from './FiltersAgreementType';
import { FiltersArticleBrand } from './FiltersArticleBrand';
import { FiltersArticleWorkshop } from './FiltersArticleWorkshop';
import { FiltersEntityOrGroup } from './FiltersEntityOrGroup';
import { FiltersHasClient } from './FiltersHasClient';

export const DesktopFilters = () => {
  const { t } = useLingui();
  const [organization] = useCurrentOrganization();

  const { search, activeFiltersCount, clearFilters } = useFilters();

  const { data: brandsData } = useBrands({
    organizationId: organization?.id,
    limit: 500,
    offset: 0,
  });

  const showBrandFilter = !!brandsData?.brands && brandsData.brands.length > 1;

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <FiltersMenu button={<FiltersButton />}>
          <FiltersAgreementType />
          <FiltersEntityOrGroup />
          <FiltersHasClient />
          {showBrandFilter ? <FiltersArticleBrand /> : null}
          <FiltersArticleWorkshop />
        </FiltersMenu>
        <InputSearch
          ariaLabel={t({
            id: 'settings.organization.entities.agreements.search.label',
            message: 'Search agreements',
          })}
          placeholder={t({
            id: 'settings.organization.entities.agreements.search.placeholder',
            message: 'Search by entity or group name…',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
        <CreateAgreementButton />
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <Stack row gap="0.5rem">
            <FiltersAgreementType tag />
            <FiltersEntityOrGroup tag />
            <FiltersHasClient tag />
            {showBrandFilter ? <FiltersArticleBrand tag /> : null}
            <FiltersArticleWorkshop tag />
          </Stack>

          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="settings.organization.entities.agreements.filters.clear_all">
              Clear filters
            </Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
